import React from 'react';
import Navigation from '../components/Navigation';
import Awards from '../components/Awards';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const AwardsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO title="Awards & Recognition" description="Manage Your Loans industry recognition: Australian Broker 5-Star Mortgage Innovators 2025, plus finalist places at the Australian Mortgage Awards, Australian Broking Awards and Broker Daily Business Awards." path="/awards" />
      <Navigation />
      <div className="pt-16">
        <Awards />
      </div>
      <Footer />
    </div>
  );
};

export default AwardsPage;
